// import * as React from "react";
// import { useState, useEffect } from "react";
// import {
//   Box,
//   Grid,
//   Typography,
//   Tabs,
//   Tab,
//   Paper,
//   CircularProgress,
//   Alert,
//   useTheme,
//   alpha,
//   MenuItem,
//   Select,
//   TextField as MuiTextField,
// } from "@mui/material";
// import { DatePicker } from "@mui/x-date-pickers";
// import {
//   VolunteerActivism as DonateIcon,
//   RequestQuote as NeedIcon,
//   Handshake as MatchIcon,
//   LocalOffer as OfferIcon,
// } from "@mui/icons-material";
// import { useNotify } from "react-admin";

// // Reusable components
// import { ExportButton, exportInKindData, GenericTable } from "../../inkind";
// import { SummaryCard } from "../teerab";
// import CombinedOverviewCharts from "./CombinedOverviewCharts";

// const token = JSON.parse(localStorage.getItem("token"));

// const fetchWithFilters = async (endpoint, filters, page = 1, limit = 50) => {
//   const params = new URLSearchParams();
//   params.append("page", page.toString());
//   params.append("limit", limit.toString());
//   if (filters.length > 0) {
//     params.append("filter", JSON.stringify(filters));
//   }
//   const url = `${process.env.REACT_APP_URL}/${endpoint}?${params.toString()}`;
//   const response = await fetch(url, {
//     method: "GET",
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//       Authorization: "Bearer " + token,
//     },
//   });
//   if (!response.ok) throw new Error(`HTTP ${response.status}`);
//   return response.json();
// };

// const CombinedInKindReport = ({ itemType }) => {
//   const theme = useTheme();
//   const notify = useNotify();
//   const isNeed = itemType === "need";

//   // Source tab: 0 = Crops, 1 = Services
//   const [sourceTab, setSourceTab] = useState(0);

//   // Filters
//   const [selectedState, setSelectedState] = useState("");
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");

//   // Meta data
//   const [states, setStates] = useState([]);
//   const [loadingMeta, setLoadingMeta] = useState(true);

//   // Data for different views
//   const [allData, setAllData] = useState({ data: [], total: 0, loading: false, typeDistribution: [], statusDistribution: [] });
//   const [activeData, setActiveData] = useState({ data: [], total: 0, loading: false });
//   const [completedData, setCompletedData] = useState({ data: [], total: 0, loading: false });
//   const [error, setError] = useState(null);
//   const [activeTab, setActiveTab] = useState(0); // 0: Overview, 1: All, 2: Active, 3: Completed

//   // Global counts for summary cards - UPDATED to include all statuses
//   const [globalCounts, setGlobalCounts] = useState({
//     crops: { total: 0, active: 0, completed: 0, deleted: 0, inProgress: 0 },
//     services: { total: 0, active: 0, completed: 0, deleted: 0, inProgress: 0 }
//   });
//   const [loadingCounts, setLoadingCounts] = useState(false);

//   // Pagination for each tab
//   const [allPage, setAllPage] = useState(0);
//   const [activePage, setActivePage] = useState(0);
//   const [completedPage, setCompletedPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   // Fetch states
//   useEffect(() => {
//     const fetchStates = async () => {
//       try {
//         const res = await fetch(`${process.env.REACT_APP_URL}/admin/state`, {
//           headers: { Accept: "application/json" },
//         });
//         const data = await res.json();
//         setStates(data);
//       } catch (err) {
//         notify("Error loading states", { type: "warning" });
//       } finally {
//         setLoadingMeta(false);
//       }
//     };
//     fetchStates();
//   }, [notify]);

//   // Build filter array for each endpoint
//   const buildFilters = (type, statusFilter = null) => {
//     const filters = [];

//     if (type === "offers") {
//       filters.push(`offer_type||$eq||${itemType}`);
//     } else {
//       filters.push(`service_type||$eq||${itemType}`);
//     }

//     if (selectedState) {
//       filters.push(`state||$eq||${selectedState}`);
//     }
//     if (selectedCategory) {
//       const field = type === "offers" ? "subCategory_id" : "service_id";
//       filters.push(`${field}||$eq||${selectedCategory}`);
//     }
//     if (startDate) {
//       filters.push(`created_at_gte||$cont||${startDate}`);
//     }
//     if (endDate) {
//       filters.push(`created_at_lte||$cont||${endDate}`);
//     }
    
//     // Add status filter if provided
//     if (statusFilter) {
//       filters.push(`status||$eq||${statusFilter}`);
//     }
    
//     return filters;
//   };

//   // Fetch data for a specific status
//   const fetchDataByStatus = async (status, page, setDataState) => {
//     setDataState(prev => ({ ...prev, loading: true }));
//     try {
//       const currentPage = page + 1;
//       const endpoint = sourceTab === 0 ? "admin/in-kind-offers" : "admin/in-kind-services";
//       const filters = buildFilters(sourceTab === 0 ? "offers" : "services", status);
      
//       const response = await fetchWithFilters(endpoint, filters, currentPage, rowsPerPage);
      
//       const items = (response.data || []).map((item) => ({
//         ...item,
//         source: sourceTab === 0 ? "crop" : "service",
//       }));
      
//       setDataState({
//         data: items,
//         total: response.total || 0,
//         loading: false,
//         typeDistribution: response.typeDistribution || [],
//         statusDistribution: response.statusDistribution || [],
//       });
//     } catch (err) {
//       console.error(`Error fetching ${status} data:`, err);
//       setDataState({
//         data: [],
//         total: 0,
//         loading: false,
//         typeDistribution: [],
//         statusDistribution: [],
//       });
//       notify(`Error loading ${status} data`, { type: "error" });
//     }
//   };

//   // Fetch all data (without status filter)
//   const fetchAllData = async () => {
//     await fetchDataByStatus(null, allPage, setAllData);
//   };

//   // Fetch active data
//   const fetchActiveData = async () => {
//     await fetchDataByStatus("active", activePage, setActiveData);
//   };

//   // Fetch completed data
//   const fetchCompletedData = async () => {
//     await fetchDataByStatus("donated", completedPage, setCompletedData);
//   };

//   // Fetch global counts for summary cards - UPDATED to fetch all statuses
//   const fetchGlobalCounts = async () => {
//     setLoadingCounts(true);
//     try {
//       const endpointOffers = "admin/in-kind-offers";
//       const endpointServices = "admin/in-kind-services";
      
//       // Fetch counts for crops (offers) - now including deleted and in_progress
//       const [activeOffersRes, completedOffersRes, deletedOffersRes, inProgressOffersRes, totalOffersRes] = await Promise.all([
//         fetchWithFilters(endpointOffers, buildFilters("offers", "active"), 1, 1),
//         fetchWithFilters(endpointOffers, buildFilters("offers", "donated"), 1, 1),
//         fetchWithFilters(endpointOffers, buildFilters("offers", "deleted"), 1, 1),
//         fetchWithFilters(endpointOffers, buildFilters("offers", "in_progress"), 1, 1),
//         fetchWithFilters(endpointOffers, buildFilters("offers"), 1, 1),
//       ]);

//       // Fetch counts for services - now including deleted and in_progress
//       const [activeServicesRes, completedServicesRes, deletedServicesRes, inProgressServicesRes, totalServicesRes] = await Promise.all([
//         fetchWithFilters(endpointServices, buildFilters("services", "active"), 1, 1),
//         fetchWithFilters(endpointServices, buildFilters("services", "donated"), 1, 1),
//         fetchWithFilters(endpointServices, buildFilters("services", "deleted"), 1, 1),
//         fetchWithFilters(endpointServices, buildFilters("services", "in_progress"), 1, 1),
//         fetchWithFilters(endpointServices, buildFilters("services"), 1, 1),
//       ]);

//       setGlobalCounts({
//         crops: {
//           total: totalOffersRes.total || 0,
//           active: activeOffersRes.total || 0,
//           completed: completedOffersRes.total || 0,
//           deleted: deletedOffersRes.total || 0,
//           inProgress: inProgressOffersRes.total || 0,
//         },
//         services: {
//           total: totalServicesRes.total || 0,
//           active: activeServicesRes.total || 0,
//           completed: completedServicesRes.total || 0,
//           deleted: deletedServicesRes.total || 0,
//           inProgress: inProgressServicesRes.total || 0,
//         }
//       });
//     } catch (err) {
//       console.error("Error fetching global counts:", err);
//       notify("Error loading summary counts", { type: "warning" });
//     } finally {
//       setLoadingCounts(false);
//     }
//   };

//   // Fetch data when dependencies change
//   useEffect(() => {
//     if (sourceTab !== undefined) {
//       fetchAllData();
//       fetchActiveData();
//       fetchCompletedData();
//     }
//   }, [selectedState, selectedCategory, startDate, endDate, sourceTab, rowsPerPage]);

//   // Fetch when pages change
//   useEffect(() => {
//     fetchAllData();
//   }, [allPage]);

//   useEffect(() => {
//     fetchActiveData();
//   }, [activePage]);

//   useEffect(() => {
//     fetchCompletedData();
//   }, [completedPage]);

//   // Fetch global counts when filters change
//   useEffect(() => {
//     fetchGlobalCounts();
//   }, [selectedState, selectedCategory, startDate, endDate, sourceTab, itemType]);

//   const handleMarkAsDonated = async (id, source) => {
//     const endpoint =
//       source === "crop"
//         ? `/admin/in-kind-offers/${id}/donated`
//         : `/admin/in-kind-services/${id}/donated`;
//     try {
//       const response = await fetch(`${process.env.REACT_APP_URL}${endpoint}`, {
//         method: "PATCH",
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//           Authorization: "Bearer " + token,
//         },
//       });
//       if (!response.ok) throw new Error("Failed to mark as donated");
//       notify("Marked as donated", { type: "success" });
//       // Refresh all data
//       fetchAllData();
//       fetchActiveData();
//       fetchCompletedData();
//       fetchGlobalCounts();
//     } catch (err) {
//       notify(err.message, { type: "error" });
//     }
//   };

//   const handleAssignDelivery = () => {
//     notify("Delivery assignment not yet implemented", { type: "info" });
//   };

//   const handleDelete = async (id, source) => {
//     if (!window.confirm("Are you sure you want to delete this item? This action cannot be undone.")) return;

//     const endpoint = source === "crop"
//       ? `admin/in-kind-offers/${id}/status`
//       : `admin/in-kind-services/${id}/status`;

//     try {
//       const response = await fetch(`${process.env.REACT_APP_URL}/${endpoint}`, {
//         method: "PATCH",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({ status: "deleted" }),
//       });

//       if (!response.ok) throw new Error("Failed to delete item");

//       notify("Item deleted successfully", { type: "success" });
//       // Refresh all data
//       fetchAllData();
//       fetchActiveData();
//       fetchCompletedData();
//       fetchGlobalCounts();
//     } catch (err) {
//       notify(err.message, { type: "error" });
//     }
//   };
  
//   const exportAllFiltered = async (status = null) => {
//     try {
//       const endpoint = sourceTab === 0 ? "admin/in-kind-offers" : "admin/in-kind-services";
//       const filters = buildFilters(sourceTab === 0 ? "offers" : "services", status);
//       const res = await fetchWithFilters(endpoint, filters, 1, 10000);
//       const allData = res.data || [];
//       if (allData.length === 0) {
//         notify("No data to export", { type: "warning" });
//         return;
//       }
//       const statusLabel = status ? `_${status.charAt(0).toUpperCase() + status.slice(1)}` : "";
//       const exportTitle = `${sourceTab === 0 ? "Crops" : "Services"}_${isNeed ? "Requests" : "Offers"}${statusLabel}`;
//       exportInKindData(allData, exportTitle, sourceTab === 1);
//       notify(`Exported ${allData.length} records`, { type: "success" });
//     } catch (err) {
//       notify("Export error: " + err.message, { type: "error" });
//     }
//   };

//   // Get current data based on active tab
//   const getCurrentData = () => {
//     switch(activeTab) {
//       case 1: return allData;
//       case 2: return activeData;
//       case 3: return completedData;
//       default: return { data: [], total: 0, loading: false };
//     }
//   };

//   // Get current page and setter based on active tab
//   const getCurrentPageHelpers = () => {
//     switch(activeTab) {
//       case 1: return { page: allPage, setPage: setAllPage };
//       case 2: return { page: activePage, setPage: setActivePage };
//       case 3: return { page: completedPage, setPage: setCompletedPage };
//       default: return { page: 0, setPage: () => {} };
//     }
//   };

//   // Get export status filter based on active tab
//   const getExportStatus = () => {
//     switch(activeTab) {
//       case 2: return "active";
//       case 3: return "donated";
//       default: return null;
//     }
//   };

//   const currentData = getCurrentData();
//   const { page, setPage } = getCurrentPageHelpers();
//   const currentGlobalCounts = sourceTab === 0 ? globalCounts.crops : globalCounts.services;

//   // Handle page change
//   const handlePageChange = (newPage) => {
//     setPage(newPage);
//   };

//   // Handle rows per page change
//   const handleRowsPerPageChange = (newRowsPerPage) => {
//     setRowsPerPage(newRowsPerPage);
//     setAllPage(0);
//     setActivePage(0);
//     setCompletedPage(0);
//   };

//   // Helper to render table
//   const renderTable = () => {
//     const title = activeTab === 1 ? "All" : (activeTab === 2 ? "Active" : "Completed");
//     const exportStatus = getExportStatus();
    
//     return (
//       <Box>
//         <Box display="flex" gap={1} sx={{ mb: 2 }}>
//           <ExportButton
//             onClick={() => exportAllFiltered(exportStatus)}
//             label={`Export All ${title}`}
//           />
//         </Box>
//         {currentData.loading ? (
//           <Box display="flex" justifyContent="center" p={4}>
//             <CircularProgress />
//           </Box>
//         ) : (
//           <GenericTable
//             data={currentData.data}
//             title={title.toLowerCase()}
//             onMarkAsDonated={handleMarkAsDonated}
//             onAssignDelivery={handleAssignDelivery}
//             isService={sourceTab === 1}
//             resourceName={sourceTab === 0 ? "admin/in-kind-offers" : "admin/in-kind-services"}
//             showAssignButton={true}
//             page={page}
//             rowsPerPage={rowsPerPage}
//             total={currentData.total}
//             onPageChange={handlePageChange}
//             onRowsPerPageChange={handleRowsPerPageChange}
//             onEdit={(id) => {
//               const basePath = sourceTab === 0 ? "/in-kind-offers" : "/in-kind-services";
//               window.location.href = `#${basePath}/${id}`;
//             }}
//             onDelete={handleDelete}
//             canEdit={true}
//             canDelete={true}
//           />
//         )}
//       </Box>
//     );
//   };

//   if (loadingMeta || loadingCounts) {
//     return (
//       <Box display="flex" justifyContent="center" p={4}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Alert severity="error" sx={{ my: 3 }}>
//         {error}
//       </Alert>
//     );
//   }

//   return (
//     <Box>
//       {/* Filters */}
//       <Grid container spacing={2} sx={{ mb: 4 }}>
//         <Grid item xs={6} sm={3} md={2}>
//           <Typography variant="subtitle2">State</Typography>
//           <Select
//             fullWidth
//             value={selectedState}
//             onChange={(e) => setSelectedState(e.target.value)}
//             displayEmpty
//             size="small"
//           >
//             <MenuItem value="">All</MenuItem>
//             {states.map((state) => (
//               <MenuItem key={state.id} value={state.id}>
//                 {state.name}
//               </MenuItem>
//             ))}
//           </Select>
//         </Grid>

//         <Grid item xs={12} sm={6} md={4}>
//           <Typography variant="subtitle2">Category / Type</Typography>
//           <Select
//             fullWidth
//             value={selectedCategory}
//             onChange={(e) => setSelectedCategory(e.target.value)}
//             displayEmpty
//             size="small"
//           >
//             <MenuItem value="">All</MenuItem>
//           </Select>
//         </Grid>

//         <Grid item xs={6} sm={3} md={2}>
//           <Typography variant="subtitle2">From</Typography>
//           <DatePicker
//             value={startDate || null}
//             onChange={(newDate) => {
//               const iso = newDate ? newDate.toISOString().slice(0, 10) : "";
//               setStartDate(iso);
//             }}
//             renderInput={(params) => (
//               <MuiTextField
//                 {...params}
//                 fullWidth
//                 size="small"
//                 inputProps={{ ...params.inputProps, readOnly: true }}
//               />
//             )}
//           />
//         </Grid>

//         <Grid item xs={6} sm={3} md={2}>
//           <Typography variant="subtitle2">To</Typography>
//           <DatePicker
//             value={endDate || null}
//             onChange={(newDate) => {
//               const iso = newDate ? newDate.toISOString().slice(0, 10) : "";
//               setEndDate(iso);
//             }}
//             renderInput={(params) => (
//               <MuiTextField
//                 {...params}
//                 fullWidth
//                 size="small"
//                 inputProps={{ ...params.inputProps, readOnly: true }}
//               />
//             )}
//           />
//         </Grid>
//       </Grid>

//       {/* Source Tabs (Crops / Services) */}
//       <Box sx={{ mb: 3 }}>
//         <Paper
//           elevation={0}
//           sx={{
//             background: alpha(theme.palette.background.paper, 0.8),
//             backdropFilter: "blur(8px)",
//             borderRadius: "12px",
//             overflow: "hidden",
//           }}
//         >
//           <Tabs
//             value={sourceTab}
//             onChange={(e, newValue) => {
//               setSourceTab(newValue);
//               setAllPage(0);
//               setActivePage(0);
//               setCompletedPage(0);
//             }}
//             indicatorColor="primary"
//             textColor="primary"
//             variant="fullWidth"
//             sx={{
//               "& .MuiTab-root": {
//                 fontWeight: "600",
//                 textTransform: "none",
//                 fontSize: "1rem",
//               },
//             }}
//           >
//             <Tab label="Crops" />
//             <Tab label="Services" />
//           </Tabs>
//         </Paper>
//       </Box>

//       {/* Summary Cards - Showing GLOBAL totals with all statuses breakdown */}
//       <Grid container spacing={3} sx={{ mb: 4 }}>
//         <Grid item xs={12} sm={6} md={3}>
//           <SummaryCard
//             title={`${sourceTab === 0 ? "Crop" : "Service"} ${isNeed ? "Requests" : "Offers"}`}
//             value={currentGlobalCounts.total}
//             icon={isNeed ? NeedIcon : DonateIcon}
//             secondaryValue={`${currentGlobalCounts.active} active, ${currentGlobalCounts.completed} completed, ${currentGlobalCounts.deleted} deleted, ${currentGlobalCounts.inProgress} in progress`}
//             color={isNeed ? "warning" : "success"}
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <SummaryCard
//             title="Active (Total)"
//             value={currentGlobalCounts.active}
//             icon={OfferIcon}
//             secondaryValue="All active items"
//             color="info"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <SummaryCard
//             title="Completed (Total)"
//             value={currentGlobalCounts.completed}
//             icon={MatchIcon}
//             secondaryValue="Donated or sold"
//             color="primary"
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <SummaryCard
//             title="Total (both types)"
//             value={`${globalCounts.crops.total} / ${globalCounts.services.total}`}
//             icon={DonateIcon}
//             secondaryValue="Crops / Services"
//             color="secondary"
//           />
//         </Grid>
//       </Grid>

//       {/* Info note about current view */}
//       <Paper sx={{ p: 2, mb: 3, bgcolor: alpha(theme.palette.info.light, 0.1) }}>
//         <Typography variant="body2" color="text.secondary">
//           {activeTab === 0 ? (
//             "Overview charts showing data distribution"
//           ) : (
//             `Showing ${activeTab === 1 ? "all" : activeTab === 2 ? "active" : "completed"} items - Page ${page + 1} of ${Math.ceil(currentData.total / rowsPerPage)} (Total ${currentData.total} items found)`
//           )}
//         </Typography>
//       </Paper>

//       {/* Inner Tabs (Overview / All / Active / Completed) */}
//       <Box sx={{ mb: 3 }}>
//         <Paper
//           elevation={0}
//           sx={{
//             background: alpha(theme.palette.background.paper, 0.8),
//             backdropFilter: "blur(8px)",
//             borderRadius: "12px",
//             overflow: "hidden",
//           }}
//         >
//           <Tabs
//             value={activeTab}
//             onChange={(e, newValue) => {
//               setActiveTab(newValue);
//             }}
//             indicatorColor="primary"
//             textColor="primary"
//             variant="fullWidth"
//             sx={{
//               "& .MuiTab-root": {
//                 fontWeight: "600",
//                 textTransform: "none",
//                 fontSize: "0.875rem",
//               },
//             }}
//           >
//             <Tab label="Overview" />
//             <Tab label={`All ${isNeed ? "Requests" : "Offers"} (${allData.total})`} />
//             <Tab label={`Active (${currentGlobalCounts.active})`} />
//             <Tab label={`Completed (${currentGlobalCounts.completed})`} />
//           </Tabs>
//         </Paper>
//       </Box>

//       {/* Content based on inner tab */}
//       {activeTab === 0 && (
//         <CombinedOverviewCharts
//           offersData={allData.data}
//           servicesData={[]}
//           sourceTab={sourceTab}
//           isNeed={isNeed}
//         />
//       )}

//       {(activeTab === 1 || activeTab === 2 || activeTab === 3) && renderTable()}
//     </Box>
//   );
// };

// export default CombinedInKindReport;
import * as React from "react";
import { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Tabs,
  Tab,
  Paper,
  CircularProgress,
  Alert,
  useTheme,
  alpha,
  MenuItem,
  Select,
  TextField as MuiTextField,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import {
  VolunteerActivism as DonateIcon,
  RequestQuote as NeedIcon,
  Handshake as MatchIcon,
  LocalOffer as OfferIcon,
} from "@mui/icons-material";
import { useNotify } from "react-admin";

// Reusable components
import { ExportButton, exportInKindData, GenericTable } from "../../inkind";
import { SummaryCard } from "../teerab";
import CombinedOverviewCharts from "./CombinedOverviewCharts";

const token = JSON.parse(localStorage.getItem("token"));

const fetchWithFilters = async (endpoint, filters, page = 1, limit = 50) => {
  const params = new URLSearchParams();
  params.append("page", page.toString());
  params.append("limit", limit.toString());
  if (filters.length > 0) {
    params.append("filter", JSON.stringify(filters));
  }
  const url = `${process.env.REACT_APP_URL}/${endpoint}?${params.toString()}`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

const CombinedInKindReport = ({ itemType }) => {
  const theme = useTheme();
  const notify = useNotify();
  const isNeed = itemType === "need";

  // Source tab: 0 = Crops, 1 = Services
  const [sourceTab, setSourceTab] = useState(0);

  // Filters
  const [selectedState, setSelectedState] = useState("");
  const [selectedLocality, setSelectedLocality] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedContribution, setSelectedContribution] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Meta data
  const [states, setStates] = useState([]);
  const [localities, setLocalities] = useState([]);
  const [loadingMeta, setLoadingMeta] = useState(true);

  // Data for different views
  const [allData, setAllData] = useState({ data: [], total: 0, loading: false });
  const [activeData, setActiveData] = useState({ data: [], total: 0, loading: false });
  const [completedData, setCompletedData] = useState({ data: [], total: 0, loading: false });
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(0); // 0: Overview, 1: All, 2: Active, 3: Completed

  // Global counts for summary cards
  const [globalCounts, setGlobalCounts] = useState({
    crops: { total: 0, active: 0, completed: 0, deleted: 0, inProgress: 0 },
    services: { total: 0, active: 0, completed: 0, deleted: 0, inProgress: 0 }
  });
  const [loadingCounts, setLoadingCounts] = useState(false);

  // NEW: Store distributions from API for charts
  const [distributions, setDistributions] = useState({
    typeDistribution: [],
    statusDistribution: [],
    contributionDistribution: []
  });

  // Pagination for each tab
  const [allPage, setAllPage] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [completedPage, setCompletedPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Managers only see their assigned state(s) (from localStorage, set at login);
  // everyone else sees all states fetched from the backend.
  useEffect(() => {
    const role = localStorage.getItem("permissions");

    if (role === "manager") {
      try {
        const statesData = JSON.parse(localStorage.getItem("states")) || [];
        setStates(statesData);
        if (statesData.length === 1) {
          setSelectedState(statesData[0].id);
        }
      } catch (err) {
        console.error("Error loading states:", err);
        notify("Error loading states", { type: "warning" });
      } finally {
        setLoadingMeta(false);
      }
      return;
    }

    const fetchStates = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_URL}/admin/state`, {
          headers: { Accept: "application/json" },
        });
        const data = await res.json();
        setStates(data);
      } catch (err) {
        notify("Error loading states", { type: "warning" });
      } finally {
        setLoadingMeta(false);
      }
    };
    fetchStates();
  }, [notify]);

  // Fetch localities for the selected state only
  useEffect(() => {
    if (!selectedState) {
      setLocalities([]);
      return;
    }
    const fetchLocalities = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_URL}/locality/${selectedState}`, {
          headers: { Accept: "application/json" },
        });
        const data = await res.json();
        setLocalities(data.data || data);
      } catch (err) {
        notify("Error loading localities", { type: "warning" });
      }
    };
    fetchLocalities();
  }, [selectedState, notify]);

  // Reset locality selection when state changes
  useEffect(() => {
    setSelectedLocality("");
  }, [selectedState]);

  // Build filter array for each endpoint
  const buildFilters = (type, statusFilter = null) => {
    const filters = [];

    if (type === "offers") {
      filters.push(`offer_type||$eq||${itemType}`);
    } else {
      filters.push(`service_type||$eq||${itemType}`);
    }

    if (selectedState) {
      filters.push(`state||$eq||${selectedState}`);
    }
    if (selectedLocality) {
      filters.push(`locality||$eq||${selectedLocality}`);
    }
    if (selectedCategory) {
      const field = type === "offers" ? "subCategory_id" : "service_id";
      filters.push(`${field}||$eq||${selectedCategory}`);
    }
    if (selectedContribution) {
      filters.push(`contribution_percentage||$eq||${selectedContribution}`);
    }
    if (startDate) {
      filters.push(`created_at_gte||$cont||${startDate}`);
    }
    if (endDate) {
      filters.push(`created_at_lte||$cont||${endDate}`);
    }
    
    // Add status filter if provided
    if (statusFilter) {
      filters.push(`status||$eq||${statusFilter}`);
    }
    
    return filters;
  };

  // Fetch data for a specific status
  const fetchDataByStatus = async (status, page, setDataState) => {
    setDataState(prev => ({ ...prev, loading: true }));
    try {
      const currentPage = page + 1;
      const endpoint = sourceTab === 0 ? "admin/in-kind-offers" : "admin/in-kind-services";
      const filters = buildFilters(sourceTab === 0 ? "offers" : "services", status);
      
      const response = await fetchWithFilters(endpoint, filters, currentPage, rowsPerPage);
      
      const items = (response.data || []).map((item) => ({
        ...item,
        source: sourceTab === 0 ? "crop" : "service",
      }));
      
      setDataState({
        data: items,
        total: response.total || 0,
        loading: false
      });

      // NEW: Capture distributions for the "all" view (no status filter)
      if (!status) {
        setDistributions({
          typeDistribution: response.typeDistribution || [],
          statusDistribution: response.statusDistribution || [],
          contributionDistribution: response.contributionDistribution || []
        });
      }
    } catch (err) {
      console.error(`Error fetching ${status} data:`, err);
      setDataState({
        data: [],
        total: 0,
        loading: false
      });
      notify(`Error loading ${status} data`, { type: "error" });
    }
  };

  // Fetch all data (without status filter)
  const fetchAllData = async () => {
    await fetchDataByStatus(null, allPage, setAllData);
  };

  // Fetch active data
  const fetchActiveData = async () => {
    await fetchDataByStatus("active", activePage, setActiveData);
  };

  // Fetch completed data
  const fetchCompletedData = async () => {
    await fetchDataByStatus("donated", completedPage, setCompletedData);
  };

  // Fetch global counts for summary cards
  const fetchGlobalCounts = async () => {
    setLoadingCounts(true);
    try {
      const endpointOffers = "admin/in-kind-offers";
      const endpointServices = "admin/in-kind-services";
      
      // Fetch counts for crops (offers)
      const [activeOffersRes, completedOffersRes, deletedOffersRes, inProgressOffersRes, totalOffersRes] = await Promise.all([
        fetchWithFilters(endpointOffers, buildFilters("offers", "active"), 1, 1),
        fetchWithFilters(endpointOffers, buildFilters("offers", "donated"), 1, 1),
        fetchWithFilters(endpointOffers, buildFilters("offers", "deleted"), 1, 1),
        fetchWithFilters(endpointOffers, buildFilters("offers", "in_progress"), 1, 1),
        fetchWithFilters(endpointOffers, buildFilters("offers"), 1, 1),
      ]);

      // Fetch counts for services
      const [activeServicesRes, completedServicesRes, deletedServicesRes, inProgressServicesRes, totalServicesRes] = await Promise.all([
        fetchWithFilters(endpointServices, buildFilters("services", "active"), 1, 1),
        fetchWithFilters(endpointServices, buildFilters("services", "donated"), 1, 1),
        fetchWithFilters(endpointServices, buildFilters("services", "deleted"), 1, 1),
        fetchWithFilters(endpointServices, buildFilters("services", "in_progress"), 1, 1),
        fetchWithFilters(endpointServices, buildFilters("services"), 1, 1),
      ]);

      setGlobalCounts({
        crops: {
          total: totalOffersRes.total || 0,
          active: activeOffersRes.total || 0,
          completed: completedOffersRes.total || 0,
          deleted: deletedOffersRes.total || 0,
          inProgress: inProgressOffersRes.total || 0,
        },
        services: {
          total: totalServicesRes.total || 0,
          active: activeServicesRes.total || 0,
          completed: completedServicesRes.total || 0,
          deleted: deletedServicesRes.total || 0,
          inProgress: inProgressServicesRes.total || 0,
        }
      });
    } catch (err) {
      console.error("Error fetching global counts:", err);
      notify("Error loading summary counts", { type: "warning" });
    } finally {
      setLoadingCounts(false);
    }
  };

  // Fetch data when dependencies change
  useEffect(() => {
    if (sourceTab !== undefined) {
      fetchAllData();
      fetchActiveData();
      fetchCompletedData();
    }
  }, [selectedState, selectedLocality, selectedCategory, selectedContribution, startDate, endDate, sourceTab, rowsPerPage]);

  // Fetch when pages change
  useEffect(() => {
    fetchAllData();
  }, [allPage]);

  useEffect(() => {
    fetchActiveData();
  }, [activePage]);

  useEffect(() => {
    fetchCompletedData();
  }, [completedPage]);

  // Fetch global counts when filters change
  useEffect(() => {
    fetchGlobalCounts();
  }, [selectedState, selectedLocality, selectedCategory, selectedContribution, startDate, endDate, sourceTab, itemType]);

  const handleMarkAsDonated = async (id, source) => {
    const endpoint =
      source === "crop"
        ? `/admin/in-kind-offers/${id}/donated`
        : `/admin/in-kind-services/${id}/donated`;
    try {
      const response = await fetch(`${process.env.REACT_APP_URL}${endpoint}`, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });
      if (!response.ok) throw new Error("Failed to mark as donated");
      notify("Marked as donated", { type: "success" });
      // Refresh all data
      fetchAllData();
      fetchActiveData();
      fetchCompletedData();
      fetchGlobalCounts();
    } catch (err) {
      notify(err.message, { type: "error" });
    }
  };

  const handleAssignDelivery = () => {
    notify("Delivery assignment not yet implemented", { type: "info" });
  };

  const handleContributionUpdated = () => {
    fetchAllData();
    fetchActiveData();
    fetchCompletedData();
    fetchGlobalCounts();
  };

  const handleDelete = async (id, source) => {
    if (!window.confirm("Are you sure you want to delete this item? This action cannot be undone.")) return;

    const endpoint = source === "crop"
      ? `admin/in-kind-offers/${id}/status`
      : `admin/in-kind-services/${id}/status`;

    try {
      const response = await fetch(`${process.env.REACT_APP_URL}/${endpoint}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status: "deleted" }),
      });

      if (!response.ok) throw new Error("Failed to delete item");

      notify("Item deleted successfully", { type: "success" });
      // Refresh all data
      fetchAllData();
      fetchActiveData();
      fetchCompletedData();
      fetchGlobalCounts();
    } catch (err) {
      notify(err.message, { type: "error" });
    }
  };
  
  const exportAllFiltered = async (status = null) => {
    try {
      const endpoint = sourceTab === 0 ? "admin/in-kind-offers" : "admin/in-kind-services";
      const filters = buildFilters(sourceTab === 0 ? "offers" : "services", status);
      const res = await fetchWithFilters(endpoint, filters, 1, 10000);
      const allData = res.data || [];
      if (allData.length === 0) {
        notify("No data to export", { type: "warning" });
        return;
      }
      const statusLabel = status ? `_${status.charAt(0).toUpperCase() + status.slice(1)}` : "";
      const exportTitle = `${sourceTab === 0 ? "Crops" : "Services"}_${isNeed ? "Requests" : "Offers"}${statusLabel}`;
      exportInKindData(allData, exportTitle, sourceTab === 1);
      notify(`Exported ${allData.length} records`, { type: "success" });
    } catch (err) {
      notify("Export error: " + err.message, { type: "error" });
    }
  };

  // Get current data based on active tab
  const getCurrentData = () => {
    switch(activeTab) {
      case 1: return allData;
      case 2: return activeData;
      case 3: return completedData;
      default: return { data: [], total: 0, loading: false };
    }
  };

  // Get current page and setter based on active tab
  const getCurrentPageHelpers = () => {
    switch(activeTab) {
      case 1: return { page: allPage, setPage: setAllPage };
      case 2: return { page: activePage, setPage: setActivePage };
      case 3: return { page: completedPage, setPage: setCompletedPage };
      default: return { page: 0, setPage: () => {} };
    }
  };

  // Get export status filter based on active tab
  const getExportStatus = () => {
    switch(activeTab) {
      case 2: return "active";
      case 3: return "donated";
      default: return null;
    }
  };

  const currentData = getCurrentData();
  const { page, setPage } = getCurrentPageHelpers();
  const currentGlobalCounts = sourceTab === 0 ? globalCounts.crops : globalCounts.services;

  // Handle page change
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setAllPage(0);
    setActivePage(0);
    setCompletedPage(0);
  };

  // Helper to render table
  const renderTable = () => {
    const title = activeTab === 1 ? "All" : (activeTab === 2 ? "Active" : "Completed");
    const exportStatus = getExportStatus();
    
    return (
      <Box>
        <Box display="flex" gap={1} sx={{ mb: 2 }}>
          <ExportButton
            onClick={() => exportAllFiltered(exportStatus)}
            label={`Export All ${title}`}
          />
        </Box>
        {currentData.loading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : (
          <GenericTable
            data={currentData.data}
            title={title.toLowerCase()}
            onMarkAsDonated={handleMarkAsDonated}
            onAssignDelivery={handleAssignDelivery}
            isService={sourceTab === 1}
            resourceName={sourceTab === 0 ? "admin/in-kind-offers" : "admin/in-kind-services"}
            showAssignButton={true}
            page={page}
            rowsPerPage={rowsPerPage}
            total={currentData.total}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            onEdit={(id) => {
              const basePath = sourceTab === 0 ? "/in-kind-offers" : "/in-kind-services";
              window.location.href = `#${basePath}/${id}`;
            }}
            onDelete={handleDelete}
            onContributionUpdated={handleContributionUpdated}
            canEdit={true}
            canDelete={true}
            showContribution={!isNeed}
          />
        )}
      </Box>
    );
  };

  if (loadingMeta || loadingCounts) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ my: 3 }}>
        {error}
      </Alert>
    );
  }

  return (
    <Box>
      {/* Filters */}
      <Grid container spacing={2} sx={{ mb: 4 }}>
        {states.length > 1 && (
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle2">State</Typography>
            <Select
              fullWidth
              value={selectedState}
              onChange={(e) => setSelectedState(e.target.value)}
              displayEmpty
              size="small"
            >
              <MenuItem value="">All</MenuItem>
              {states.map((state) => (
                <MenuItem key={state.id} value={state.id}>
                  {state.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        )}

        <Grid item xs={6} sm={3} md={2}>
          <Typography variant="subtitle2">Locality</Typography>
          <Select
            fullWidth
            value={selectedLocality}
            onChange={(e) => setSelectedLocality(e.target.value)}
            displayEmpty
            size="small"
            disabled={!selectedState}
          >
            <MenuItem value="">All</MenuItem>
            {localities.map((locality) => (
              <MenuItem key={locality.id} value={locality.id}>
                {locality.name}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="subtitle2">Category / Type</Typography>
          <Select
            fullWidth
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
            displayEmpty
            size="small"
          >
            <MenuItem value="">All</MenuItem>
          </Select>
        </Grid>

        {!isNeed && (
          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle2">Contribution %</Typography>
            <Select
              fullWidth
              value={selectedContribution}
              onChange={(e) => setSelectedContribution(e.target.value)}
              displayEmpty
              size="small"
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="10">10%</MenuItem>
              <MenuItem value="20">20%</MenuItem>
            </Select>
          </Grid>
        )}

        <Grid item xs={6} sm={3} md={2}>
          <Typography variant="subtitle2">From</Typography>
          <DatePicker
            value={startDate || null}
            onChange={(newDate) => {
              const iso = newDate ? newDate.toISOString().slice(0, 10) : "";
              setStartDate(iso);
            }}
            renderInput={(params) => (
              <MuiTextField
                {...params}
                fullWidth
                size="small"
                inputProps={{ ...params.inputProps, readOnly: true }}
              />
            )}
          />
        </Grid>

        <Grid item xs={6} sm={3} md={2}>
          <Typography variant="subtitle2">To</Typography>
          <DatePicker
            value={endDate || null}
            onChange={(newDate) => {
              const iso = newDate ? newDate.toISOString().slice(0, 10) : "";
              setEndDate(iso);
            }}
            renderInput={(params) => (
              <MuiTextField
                {...params}
                fullWidth
                size="small"
                inputProps={{ ...params.inputProps, readOnly: true }}
              />
            )}
          />
        </Grid>
      </Grid>

      {/* Source Tabs (Crops / Services) */}
      <Box sx={{ mb: 3 }}>
        <Paper
          elevation={0}
          sx={{
            background: alpha(theme.palette.background.paper, 0.8),
            backdropFilter: "blur(8px)",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          <Tabs
            value={sourceTab}
            onChange={(e, newValue) => {
              setSourceTab(newValue);
              setAllPage(0);
              setActivePage(0);
              setCompletedPage(0);
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            sx={{
              "& .MuiTab-root": {
                fontWeight: "600",
                textTransform: "none",
                fontSize: "1rem",
              },
            }}
          >
            <Tab label="Crops" />
            <Tab label="Services" />
          </Tabs>
        </Paper>
      </Box>

      {/* Summary Cards - Showing GLOBAL totals with all statuses breakdown */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryCard
            title={`${sourceTab === 0 ? "Crop" : "Service"} ${isNeed ? "Requests" : "Offers"}`}
            value={currentGlobalCounts.total}
            icon={isNeed ? NeedIcon : DonateIcon}
            secondaryValue={`${currentGlobalCounts.active} active, ${currentGlobalCounts.completed} completed, ${currentGlobalCounts.deleted} deleted, ${currentGlobalCounts.inProgress} in progress`}
            color={isNeed ? "warning" : "success"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryCard
            title="Active (Total)"
            value={currentGlobalCounts.active}
            icon={OfferIcon}
            secondaryValue="All active items"
            color="info"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryCard
            title="Completed (Total)"
            value={currentGlobalCounts.completed}
            icon={MatchIcon}
            secondaryValue="Donated or sold"
            color="primary"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <SummaryCard
            title="Total (both types)"
            value={`${globalCounts.crops.total} / ${globalCounts.services.total}`}
            icon={DonateIcon}
            secondaryValue="Crops / Services"
            color="secondary"
          />
        </Grid>
      </Grid>

      {/* Info note about current view */}
      <Paper sx={{ p: 2, mb: 3, bgcolor: alpha(theme.palette.info.light, 0.1) }}>
        <Typography variant="body2" color="text.secondary">
          {activeTab === 0 ? (
            "Overview charts showing data distribution"
          ) : (
            `Showing ${activeTab === 1 ? "all" : activeTab === 2 ? "active" : "completed"} items - Page ${page + 1} of ${Math.ceil(currentData.total / rowsPerPage)} (Total ${currentData.total} items found)`
          )}
        </Typography>
      </Paper>

      {/* Inner Tabs (Overview / All / Active / Completed) */}
      <Box sx={{ mb: 3 }}>
        <Paper
          elevation={0}
          sx={{
            background: alpha(theme.palette.background.paper, 0.8),
            backdropFilter: "blur(8px)",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => {
              setActiveTab(newValue);
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            sx={{
              "& .MuiTab-root": {
                fontWeight: "600",
                textTransform: "none",
                fontSize: "0.875rem",
              },
            }}
          >
            <Tab label="Overview" />
            <Tab label={`All ${isNeed ? "Requests" : "Offers"} (${allData.total})`} />
            <Tab label={`Active (${currentGlobalCounts.active})`} />
            <Tab label={`Completed (${currentGlobalCounts.completed})`} />
          </Tabs>
        </Paper>
      </Box>

      {/* Content based on inner tab - UPDATED to pass distributions */}
      {activeTab === 0 && (
        <CombinedOverviewCharts
          typeDistribution={distributions.typeDistribution}
          statusDistribution={distributions.statusDistribution}
          contributionDistribution={distributions.contributionDistribution}
          sourceTab={sourceTab}
          isNeed={isNeed}
        />
      )}

      {(activeTab === 1 || activeTab === 2 || activeTab === 3) && renderTable()}
    </Box>
  );
};

export default CombinedInKindReport;